import React, { Component } from "react";
import { FormBuilder, FieldGroup, Validators } from "react-reactive-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faMinusCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./Login.scss";
import Logo from "../../assets/Images/logo.png";
import axios from "../../axios.js";
import ApiURL from "../../services/ApiURL";
import { pattern } from "../../services/subscriberService";
import { UniqueID, CheckValue } from "../../services/CommonFunction";
import { setAccessTokenRespone } from "../../services/CallApi";
import { ErrorUI } from "../../components/UI/Modals/Modals";
import { staticVar } from "../../services/Constants";
import { connect } from "react-redux";
import { updateSidebar } from "../../store/utilsSlice.js";
import PasswordUI from "../../components/UI/FormInput/Password.js";
import Email from "../../components/UI/FormInput/Email.js";

class Login extends Component {
  state = {
    remember: false,
    count: 0,
  };

  loginForm = FormBuilder.group({
    email: ["", [Validators.required, Validators.pattern(pattern.username)]],
    password: [
      "",
      [Validators.required, Validators.minLength(10), Validators.maxLength(50)],
    ],
    loginError: [""],
  });

  checkCount = async () => {
    await this.setState((prevState) => ({
      count: prevState.count + 1,
    }));
    if (this.state.count > 4) {
      this.props.history.push({ pathname: "/localUrl" });
    }
    if (this.state.count === 1) {
      setTimeout(() => {
        this.setState({
          count: 0,
        });
      }, 5000);
    }
  };
  gcd = (a, b) => {
    return b === 0 ? a : this.gcd(b, a % b);
  };

  componentDidMount() {
    localStorage.removeItem("joinGym");
    localStorage.removeItem("formStep");
    if (localStorage.getItem("verificationStep") !== null) {
      localStorage.removeItem("verificationStep");
    }
    if (localStorage.getItem("loginData") !== null) {
      const obj = JSON.parse(localStorage.getItem("loginData"));
      this.loginForm.patchValue({
        email: obj.email,
        password: obj.password,
      });
      this.setState({ remember: true });
    }
  }

  // ===============form submit handler===============

  handleSubmit = (e) => {
    e.preventDefault();
    if (localStorage.getItem("accessToken")) {
      ErrorUI("Already Login", null, {
        cancelText: "Ok",
        close: () => this.props.history.push({ pathname: "/" }),
      });
    } else if (this.loginForm.valid) {
      const formData = {
        email: this.loginForm.value.email,
        password: this.loginForm.value.password,
        app_version: "0",
        timezone_offset: "0",
        device_type: "WEB",
        device_id: (+new Date()).toString() + UniqueID(),
        device_token: "0",
      };
      localStorage.removeItem("formStep");
      localStorage.removeItem("gymId");
      axios
        .post(ApiURL._login, formData)
        .then(async (response) => {
          staticVar.accessToken = response.data.data.access_token;
          localStorage.setItem("accessToken", response.data.data.access_token);
          localStorage.setItem("setId", formData.device_id);
          if (this.state.remember) {
            localStorage.setItem(
              "loginData",
              JSON.stringify(this.loginForm.value)
            );
          } else {
            localStorage.removeItem("loginData");
          }
          setAccessTokenRespone(response, this.props).then((res) => {
            HubSpot(res.data);
            if (res.gymsArray.length) {
              this.props.updateSidebar(true);
              if (
                res.gymsArray[0].linked_status === 1 &&
                (res.data.coach_profile_step === 0 ||
                  res.data.coach_profile_step === null)
              ) {
                localStorage.setItem("formStep", 1);
                this.props.history.push({ pathname: "/SignUpSteps" });
                return;
              }
              this.props.history.push({ pathname: "/" });
            } else {
              if (res.coachStatus.text === "invite") {
                this.props.history.push({ pathname: "/setPassword" });
              } else {
                localStorage.setItem(
                  "formStep",
                  CheckValue(res.data.coach_profile_step)
                    ? res.data.coach_profile_step
                    : 0
                );
                this.props.history.push({ pathname: "/SignUpSteps" });
                //     return ;
                // } else {
                //     this.props.history.push({ pathname: '/' });
              }
            }
          });
        })
        .catch((err) => {
          if (err.response) {
            this.loginForm.patchValue({
              loginError: err.response.data.message,
            });
            setTimeout(() => {
              this.loginForm.patchValue({
                loginError: "",
              });
            }, 5000);
          } else {
            ErrorUI(err.response);
          }
        });
    }
  };

  goToSignUp = () => this.props.history.push("/SignUp");

  goToForgotPassword = () => this.props.history.push("/ForgotPassword");

  rememberMeHandler = (value) => {
    this.setState({ remember: value });
  };

  render() {
    return (
      <BackGround
        clas="Login"
        count={this.state.count}
        checkCount={this.checkCount}
      >
        <div className="signup_form">
          <p className="signup_form_title">Log in</p>
          <FieldGroup
            control={this.loginForm}
            render={({ get, invalid }) => (
              <form onSubmit={this.handleSubmit}>
                <Email keyName="email" label="Email address" />
                <PasswordUI
                  form={this.loginForm}
                  keyName="password"
                  label="Password"
                  get={get}
                />
                <div className="login">
                  <span>{this.loginForm.value.loginError}</span>
                  <button
                    style={{ backgroundColor: invalid ? "#808080" : "#F22B5D" }}
                  >
                    Log in
                  </button>
                </div>
              </form>
            )}
          />
          <div className="remember_div">
            <p className="remember_text">
              {this.state.remember ? (
                <FontAwesomeIcon
                  onClick={() => this.rememberMeHandler(false)}
                  className="valid marginR8"
                  icon={faCheckCircle}
                />
              ) : (
                <FontAwesomeIcon
                  onClick={() => this.rememberMeHandler(true)}
                  className="error marginR8"
                  icon={faMinusCircle}
                />
              )}
              Remember me
            </p>
            <p className="forgot_text" onClick={this.goToForgotPassword}>
              Forgot your password?
            </p>
          </div>
          <div className="terms_div">
            <p>
              Are you a new user? <span onClick={this.goToSignUp}>Sign Up</span>
            </p>
          </div>
        </div>
      </BackGround>
    );
  }
}

const mapStateToProps = (state) => ({
  utilsData: { ...state.utilsData.data },
  userDetail: { ...state.userData.data },
});
const mapDispatchToProps = (dispatch) => ({
  updateSidebar: (e) => dispatch(updateSidebar(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);

export const BackGround = (props) => {
  return (
    <section className={props.clas}>
      {/* poster = {src} */}
      <video autoPlay muted loop id="myVideo" preload="metadata">
        <source
          src={"https://tribe-website-videos.s3.amazonaws.com/login.mp4"}
          type="video/mp4"
        />
        {/* <source src={selectIcon('loginVideo')} type="video/mp4" /> */}
      </video>
      <div className="banner_image">
        <div className="container">
          <div className="tuneup_div">
            <img
              onClick={props.checkCount ? props.checkCount : null}
              className="logo"
              src={Logo}
              alt="LOGO"
            />

            {props.children}

            <div className="everyone_needs">
              <h1>HELPING LOCAL GYMS</h1>
              <h1>GO VIRTUAL</h1>
              <p>
                An interactive, online fitness platform for local fitness
                studios
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const HubSpot = async (data) => {
  var _hsq = (window._hsq = window._hsq || []);
  const data1 = {
    email: "abc@yopmail.com" || data.email,
    firstname: "Nishant" || data.first_name || "",
    lastname: "Garg" || data.last_name || "",
    user_type:
      "Hello" || data.roles.length
        ? data.roles.includes("GYM_OWNER") || data.roles.includes("GYM_ADMIN")
          ? "GYM_OWNER"
          : "Coach"
        : "",
  };
  _hsq.push(["identify", { ...data1 }]);
};
